export const isNoiseLevelDanger = (
  noiseLevel: number,
  raw_zone: string,
) => {
  const currentHour = new Date().getHours();
  const isDay = currentHour < 22 && currentHour >= 6;
  const zone = getZoneName(raw_zone);
  switch (zone) {
    case 'commercial':
      if (isDay) return noiseLevel < 65;
      return noiseLevel < 55;
    case 'industrial':
      if (isDay) return noiseLevel < 75;
      return noiseLevel < 70;
    case 'residential':
      if (isDay) return noiseLevel < 55;
      return noiseLevel < 45;
    case 'silence':
      if (isDay) return noiseLevel < 50;
      return noiseLevel < 40;
    default:
      return false;
  }
};

const getZoneName = (raw_zone: string) => {
  const zone = raw_zone.toLowerCase();
  if (zone.search('commercial') > -1) return 'commercial';
  if (zone.search('industrial') > -1) return 'industrial';
  if (zone.search('residential') > -1) return 'residential';
  if (zone.search('silence') > -1) return 'silence';
  return 'unknown';
};

export const getNoiseLevelColorCode = (
  noiseLevel: number,
  zone: string,
) => {
  const isOk = isNoiseLevelDanger(noiseLevel, zone);
  return isOk ? '#1d9927' : 'red';
};
